module.exports = __webpack_public_path__ + "7d2c627e535272ab5736a20ad7489fad.svg";